/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SetupTaskResponse = {
    id: string;
    type: SetupTaskResponse.type;
    params?: Record<string, any> | null;
    deepLink: string;
    provider?: string | null;
    priority: SetupTaskResponse.priority;
    status: SetupTaskResponse.status;
};
export namespace SetupTaskResponse {
    export enum type {
        CONNECT_ZOOM = 'connect-zoom',
        CONNECT_MICROSOFT_TEAMS = 'connect-microsoft-teams',
        CONNECT_GOOGLE_CALENDAR = 'connect-google-calendar',
        CONNECT_MICROSOFT_CALENDAR = 'connect-microsoft-calendar',
        CONNECT_ICAL_CALENDAR = 'connect-ical-calendar',
        INVITE_CLIENTS = 'invite-clients',
        PAYMENT_METHODS = 'payment-methods',
        ACCOUNTING_OAUTH = 'accounting-oauth',
    }
    export enum priority {
        LOW = 'low',
        MEDIUM = 'medium',
        HIGH = 'high',
    }
    export enum status {
        OPEN = 'open',
        DONE = 'done',
        DISMISSED = 'dismissed',
    }
}

